import { db } from '../config/firebase';
import { collection, getDocs, doc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { C } from './programData';

// ══════════════════════════════════════════════════════════════════════
//  KUUNGANISHA DATA YENYEWE
//  Wanafunzi na wazazi waliokwisha kusajiliwa hawana haja ya kuingizwa
//  tena kwa mkono. App inawaleta yenyewe kwenye Programu ya Msaada mara
//  ya kwanza inapofunguliwa — na watoto wanaingia Chess moja kwa moja.
//
//  Ni salama kabisa: ID inatengenezwa kutokana na chanzo, hivyo
//  ikirudiwa mara elfu hakuna nakala ya pili. Collections za zamani
//  (`students`, `parents`) hazibadilishwi wala kufutwa.
// ══════════════════════════════════════════════════════════════════════

let ranThisSession = false;

export async function ensureMsaadaMembers({ force = false } = {}) {
  if (ranThisSession && !force) return null;
  ranThisSession = true;

  try {
    const [st, pa, me] = await Promise.all([
      getDocs(collection(db, 'students')),
      getDocs(collection(db, 'parents')),
      getDocs(collection(db, C.members)),
    ]);

    const existing = {};
    me.docs.forEach(d => { existing[d.id] = d.data(); });

    let imported = 0;
    let linked = 0;

    // ── Wanafunzi → mtoto (Msaada + Chess) ─────────────────────────────
    for (const d of st.docs) {
      const s = d.data();
      const id = `legacy__student__${d.id}`;
      if (existing[id]) {
        // Yupo tayari — hakikisha tu yuko kwenye Chess pia
        const ids = existing[id].programIds || [];
        if (!ids.includes('chess')) {
          await updateDoc(doc(db, C.members, id), {
            programIds: [...ids, 'chess'], updatedAt: serverTimestamp(),
          });
          linked++;
        }
        continue;
      }
      await setDoc(doc(db, C.members, id), {
        type: 'mtoto',
        firstName: s.firstName || '',
        lastName: s.lastName || '',
        fullName: `${s.firstName || ''} ${s.lastName || ''}`.trim() || 'Mwanafunzi',
        gender: s.gender || '',
        dob: s.dateOfBirth || '',
        school: s.school || '',
        className: s.class || '',
        area: s.ward || s.district || '',
        parentName: s.parentName || '',
        parentPhone: s.parentPhone || '',
        notes: s.notes || '',
        chessLevel: 'Mchipukizi',
        programIds: ['msaada', 'chess'],
        active: true,
        sourceType: 'student',
        sourceId: d.id,
        syncedAt: serverTimestamp(),
      }, { merge: true });
      imported++;
    }

    // ── Wazazi → mzazi (Msaada tu; chess kwao ni hiari) ────────────────
    for (const d of pa.docs) {
      const p = d.data();
      const id = `legacy__parent__${d.id}`;
      if (existing[id]) continue;
      await setDoc(doc(db, C.members, id), {
        type: 'mzazi',
        firstName: p.firstName || '',
        lastName: p.lastName || '',
        fullName: `${p.firstName || ''} ${p.lastName || ''}`.trim() || 'Mzazi',
        gender: p.gender || '',
        phone: p.phone || '',
        area: p.ward || p.region || '',
        businessName: p.businessType || p.businessName || '',
        hasCapital: !!(p.capitalGiven || p.hasCapital || p.businessType || p.capitalAmount),
        learnsChess: false,
        notes: p.storyBefore || p.notes || '',
        programIds: ['msaada'],
        active: true,
        sourceType: 'parent',
        sourceId: d.id,
        syncedAt: serverTimestamp(),
      }, { merge: true });
      imported++;
    }

    // ── Watoto wengine wa Msaada waingie Chess ─────────────────────────
    for (const [id, m] of Object.entries(existing)) {
      if (m.type !== 'mtoto') continue;
      const ids = m.programIds || [];
      if (!ids.includes('msaada') || ids.includes('chess')) continue;
      await updateDoc(doc(db, C.members, id), {
        programIds: [...ids, 'chess'], updatedAt: serverTimestamp(),
      });
      linked++;
    }

    return { imported, linked };
  } catch (err) {
    // Ikishindikana (mf. mtandao au ruhusa), App inaendelea kama kawaida
    console.error('Usawazishaji wa Msaada haukukamilika:', err);
    ranThisSession = false;
    return null;
  }
}
